import { roundToNearest } from '~/utils/pricing2026';
import { usePricesCurrency } from './usePricesCurrency';
import { useExchangeRates } from './useExchangeRates';

// Public-site markup для защиты от колебаний курса между моментом расчёта
// и моментом фактической оплаты гостем (плюс банковская комиссия + округление вверх).
// В админ-инструментах используется raw банковский курс — для согласованности
// с банковскими выписками. Один источник правды на оба места.
export const GEL_MARKUP = 1.03;
export const RUB_MARKUP = 1.05;

// Centralises USD→{GEL,RUB} conversion + rounding rules so PriceTable
// and QuoteRows render identical numbers for the same input.
export function usePriceFormatter() {
  const currency = usePricesCurrency();
  const { data: rates } = useExchangeRates();

  function formatUsd(usd: number): string {
    return `$${usd}`;
  }

  function formatGel(usd: number): string {
    const v = usd * (rates.value?.gel ?? 2.72) * GEL_MARKUP;
    return `${roundToNearest(v, 10)} ₾`;
  }

  function formatRub(usd: number): string {
    const v = usd * (rates.value?.rub ?? 85) * RUB_MARKUP;
    return `${roundToNearest(v, 100)} ₽`;
  }

  function format(usd: number): string {
    if (currency.value === 'USD') return formatUsd(usd);
    if (currency.value === 'GEL') return formatGel(usd);
    return formatRub(usd);
  }

  return { format, formatUsd, formatGel, formatRub, currency };
}
